// extracted by mini-css-extract-plugin
export default {"FavoritedBand":"FavoritedBand-module-c74b3565f36688a5dfdc","content":"FavoritedBand-module-e5d2d7849567f05c401b"};